(function () {
  function initSlider(root) {
    if (!root || root.getAttribute('data-hero-slider-ready') === 'true') return;
    root.setAttribute('data-hero-slider-ready', 'true');

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (!slides.length) return;

    var overlay = root.querySelector('.showroom-hero__media-overlay');
    var duration = Number(root.getAttribute('data-image-duration') || 5) * 1000;
    if (!duration || duration < 1000) duration = 5000;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer;

    function videoOf(slide) {
      return slide ? slide.querySelector('video') : null;
    }

    function buildSrcsetFromWidths(baseUrl, widthsCsv) {
      if (!baseUrl || !widthsCsv) return '';
      return widthsCsv
        .split(',')
        .map(function (w) {
          var width = String(w).trim();
          if (!width) return '';
          var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
          return baseUrl + separator + 'width=' + width + ' ' + width + 'w';
        })
        .filter(Boolean)
        .join(', ');
    }

    function ensureSlideMediaLoaded(slide) {
      if (!slide || slide.getAttribute('data-hero-media-loaded') === 'true') return;

      var deferredImage = slide.querySelector('img[data-hero-defer-image]');
      if (deferredImage && !deferredImage.getAttribute('src')) {
        var src = deferredImage.getAttribute('data-hero-src');
        if (src) {
          deferredImage.setAttribute('src', src);
          var sizes = deferredImage.getAttribute('data-hero-sizes');
          if (sizes) deferredImage.setAttribute('sizes', sizes);
          var srcset = buildSrcsetFromWidths(src, deferredImage.getAttribute('data-hero-widths'));
          if (srcset) deferredImage.setAttribute('srcset', srcset);
        }
      }

      var video = videoOf(slide);
      if (video && !video.querySelector('source')) {
        var template = slide.querySelector('template[data-hero-video-sources]');
        if (template && template.content) {
          video.appendChild(template.content.cloneNode(true));
        }
        video.preload = 'auto';
        video.load();
      }

      slide.setAttribute('data-hero-media-loaded', 'true');
      slide.removeAttribute('data-hero-media-deferred');
    }

    function preloadUpcomingSlide(nextIndex) {
      var slide = slides[nextIndex];
      if (slide) ensureSlideMediaLoaded(slide);
    }

    function setLoading(slide, loading) {
      if (!slide) return;
      slide.classList.toggle('is-loading', Boolean(loading));
    }

    function bindVideo(slide) {
      var video = videoOf(slide);
      if (!video || video.getAttribute('data-hero-bound') === 'true') return;
      video.setAttribute('data-hero-bound', 'true');

      var hideLoader = function () {
        slide.setAttribute('data-video-started', 'true');
        setLoading(slide, false);
      };
      var showLoader = function () {
        if (slide.getAttribute('data-video-started') === 'true') return;
        setLoading(slide, true);
      };

      if (video.readyState >= 2) hideLoader();
      else showLoader();

      video.addEventListener('play', hideLoader);
      video.addEventListener('playing', hideLoader);
      video.addEventListener('canplay', hideLoader);
      video.addEventListener('loadeddata', hideLoader);
      video.addEventListener('waiting', showLoader);
    }

    function stopVideo(slide) {
      var video = videoOf(slide);
      if (!video) return;
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {}
    }

    function playVideo(slide) {
      var video = videoOf(slide);
      if (!video) return;
      video.muted = true;
      if (video.readyState < 2) setLoading(slide, true);
      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(function () {
          slide.setAttribute('data-video-started', 'true');
          setLoading(slide, false);
        }).catch(function () {});
      }
    }

    function syncOverlay(slide) {
      if (!overlay) return;
      var enabled = slide && slide.getAttribute('data-overlay') === 'true';
      if (!enabled) {
        overlay.classList.remove('is-visible');
        return;
      }
      overlay.style.setProperty('--hero-overlay-color', slide.getAttribute('data-overlay-color') || '#0e2a3d');
      overlay.style.setProperty('--hero-overlay-opacity', slide.getAttribute('data-overlay-opacity') || '0.28');
      overlay.classList.add('is-visible');
    }

    function show(nextIndex) {
      if (nextIndex === index && slides[index] && slides[index].classList.contains('is-active')) {
        schedule();
        return;
      }

      slides.forEach(function (slide, i) {
        var on = i === nextIndex;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (!on) stopVideo(slide);
      });

      index = nextIndex;
      ensureSlideMediaLoaded(slides[index]);
      syncOverlay(slides[index]);
      playVideo(slides[index]);
      preloadUpcomingSlide((index + 1) % slides.length);
      schedule();
    }

    function next() {
      show((index + 1) % slides.length);
    }

    function schedule() {
      clearTimeout(timer);
      var slide = slides[index];
      var video = videoOf(slide);
      if (video) {
        video.onended = function () {
          if (slides.length < 2) {
            video.currentTime = 0;
            playVideo(slide);
            return;
          }
          next();
        };
        return;
      }
      if (reduceMotion || slides.length < 2) return;
      timer = setTimeout(next, duration);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(timer);
        stopVideo(slides[index]);
      } else {
        playVideo(slides[index]);
        schedule();
      }
    });

    slides.forEach(function (slide, i) {
      bindVideo(slide);
      slide.classList.toggle('is-active', i === 0);
      slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      if (i === 0) ensureSlideMediaLoaded(slide);
      else stopVideo(slide);
    });
    syncOverlay(slides[0]);
    playVideo(slides[0]);
    schedule();
  }

  function scan(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll('[data-showroom-hero-slider]') : [];
    Array.prototype.forEach.call(nodes, initSlider);
    if (root.matches && root.matches('[data-showroom-hero-slider]')) initSlider(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
